import apiRequest from './apiRequest';

export type ExternalMediaResponse = {
  mediaID: string;
  mediaName: string;
  fileExtension: string;
  createdAt: string;
  createdBy: string;
  mediaDownloadURL: string;
  thumbnailDownloadURL: string;
};

/** GET /media/{mediaID} on external-mogen (API key). Returns presigned URLs for the uploaded asset. */
export default async function getExternalMediaById(
  mediaID: string,
  apiKey: string,
): Promise<ExternalMediaResponse> {
  const { data, error } = await apiRequest<ExternalMediaResponse>(
    'external-mogen',
    `/media/${encodeURIComponent(mediaID)}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
  if (error) throw error;
  return data!;
}
